module.exports = {"Header":{"Home":"首页","Product Introduce":"产品介绍","Industries":"解决方案","System advantages":"系统优势","About":"关于","Downloed":"下载","China":"中文","English":"英文"},"Home":{"About us":"关于我们","Contact us":"联系我们","Email":"liu@hawk-sight.com","Phone":"135 2871 7233"},"footer":{"Home":"首页"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/Language/zh.json
// module id = PEaI
// module chunks = 10